module.exports = __webpack_public_path__ + "static/media/mask-passo1.909599b1.jpg";